import React, { useState, useRef, useEffect } from "react";
import Lottie from "react-lottie-player/dist/LottiePlayerLight";
import useIntersection from "react-use/lib/useIntersection";
import random from "lodash/random";

const MAX_ANIMATION_DELAY = 6000;

export const ForestTileAnimation = ({
  animation,
  randomStart = false,
}: {
  animation: object;
  randomStart: boolean;
}) => {
  const ref = useRef(null);
  const intersection = useIntersection(ref, {});
  const [play, setPlay] = useState(false);

  const playAnimation = () => {
    if (randomStart) {
      setTimeout(() => {
        setPlay(true);
      }, random(MAX_ANIMATION_DELAY));
    } else {
      setPlay(true);
    }
  };

  useEffect(() => {
    // Only play animation when in view
    if (intersection?.isIntersecting) {
      playAnimation();
    } else {
      setPlay(false);
    }
  }, [intersection?.isIntersecting]);
  return (
    <div ref={ref}>
      <Lottie animationData={animation} play={play} loop />
    </div>
  );
};
